import React from "react";
import Select from "../../../Select";
import {DeserializedElement, DeserializedElementRule} from "../../slate/Transformation";
import {Editor, Element as SlateElement, Node, Transforms} from "slate";

const headers = [1,2,3,4,5,6].map((key) => (
    {key: "h" + key, label: key + ". Fejléc"}
));

const toolbarButton = ({editor, isActive, disabled}: {editor?: Editor, isActive?: boolean, disabled?: boolean}) => {
    let node: Node;
    if (isActive) {
        const [match] = Editor.nodes(editor, {
            match: n => headers.map((v) => v.key).indexOf(n.type) !== -1
        });
        node = match?.[0];
    }
    return (
        <div className="headers">
            <Select
                disabled={disabled}
                storeType="local"
                options={headers}
                valueKey="key"
                labelKey="label"
                objectValue={false}
                isClearable={true}
                label={false}
                placeholder="Fejléc"
                isSearchable={false}
                value={node?.type}
                saveChanges={(field, type) => {
                    if (!type) {
                        Transforms.setNodes(editor, {type: 'p'}, {});
                        return;
                    }
                    if (!node) {
                        Transforms.setNodes(
                            editor,
                            {type},
                            {
                                match: n =>
                                    !Editor.isEditor(n) &&
                                    SlateElement.isElement(n) &&
                                    n.type === 'p'
                            });
                    } else {
                        Transforms.setNodes(editor, {type}, {
                            match: n =>
                                !Editor.isEditor(n) &&
                                SlateElement.isElement(n) &&
                                n.type === node?.type
                        });
                    }
                }}
            />
        </div>
    );
}

export const Rules: {[key: string]: DeserializedElementRule<HTMLElement>} = {
    "header": {
        isVoid: () => false,
        tagType: () => 'block',
        match: (element) => headers.map((v) => v.key).indexOf(element.type) !== -1,
        isActive: (editor) => {
            const [component] = Editor.nodes(editor, {
                match: n =>
                    !Editor.isEditor(n) && SlateElement.isElement(n) && headers.map((v) => v.key).indexOf(n.type) !== -1,
            })
            return !!component
        },
        toolbarButton,
        deserialize(el, next) {
            const name = el.tagName?.toLowerCase();
            if (headers.map((v) => v.key).indexOf(name) !== -1) {
                return {
                    type: name,
                    props: {},
                    children: next(el.childNodes)
                } as DeserializedElement;
            }
        },
        serialize(node, next) {
            if (headers.map((v) => v.key).indexOf(node.type) !== -1) {
                return <node.type>{next(node.children)}</node.type>;
            }
        },
        render: ({node}) => {
            return (headers.map((v) => v.key).indexOf(node.element?.type) !== -1 ? <node.element.type {...node.attributes}>{node.children}</node.element.type> : undefined);
        }
    }
}